import React from 'react';
import NPSMovingAverageComponent from '../components/NPSMovingAverage';

const NPSMovingAverage = () => {
    return (
        <div style={{ padding: '20px' }}>
            <NPSMovingAverageComponent />
        </div>
    );
};

export default NPSMovingAverage; 